// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 768px) {
  ._98ozf40 {
    max-width: 400px;
  }
}
@media screen and (min-width: 992px) {
  ._98ozf41 {
    width: 700px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["@media screen and (min-width: 768px) {\n  ._98ozf40 {\n    max-width: 400px;\n  }\n}\n@media screen and (min-width: 992px) {\n  ._98ozf41 {\n    width: 700px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
